// @flow
import type { TreeBranch } from "./index";

export const TYPE_ORGANIZATION = "ORGANISATIONAL_UNIT";
export const TYPE_EMPLOYEE = "EMPLOYEE_POSITION";

export type FlatNodes = {
  [key: number]: $Exact<{
    label: string,
    children: number[],
    parentId: number | null,
  }>,
};

export const flattenNodes = (
  branch: TreeBranch,
  parentId: number | null = null,
  flatNodes: FlatNodes = {},
): FlatNodes => {
  let childNodes: number[] = [];

  if (branch.children && branch.children.length > 0) {
    const children = branch.children.filter(child => child.data.type === TYPE_ORGANIZATION);
    for (let child of children) {
      childNodes.push(child.data.id);
      flattenNodes(child, branch.data.id, flatNodes);
    }
  }

  flatNodes[branch.data.id] = {
    children: childNodes,
    label: branch.data.label,
    parentId,
  };

  return flatNodes;
};

export const getParentIds = (flatNodes: FlatNodes, id: number | null): number[] => {
  let ids: number[] = [];

  if (id === null || !flatNodes[id]) {
    return ids;
  }

  let parentId = flatNodes[id].parentId;

  while (parentId !== null) {
    ids.push(parentId);
    parentId = flatNodes[parentId].parentId;
  }

  return ids;
};

export const getFirstSelectedParentId = (
  excludedId: number | null,
  selectedIds: number[],
  flatNodes: FlatNodes,
): number | null => {
  if (excludedId === null) {
    return excludedId;
  }

  const parentId = flatNodes[excludedId].parentId;

  if (selectedIds.indexOf(parentId) !== -1) {
    return parentId;
  }

  return getFirstSelectedParentId(parentId, selectedIds, flatNodes);
};
